import ScreenWrapper from '@app/hoc/ScreenWrapper'
import { ThemedText, ThemedView } from '@app/theme'
import LottieView from 'lottie-react-native'

const LIST_ITEMS = [
    {
        title: 'You will be redirected to the bank page',
    },
    {
        title: 'Approve AutoPay using bank details',
    },
    {
        title: 'You will be redirected back to continue',
    }
]




const TataEsignProgress = () => {


    return (
        <ScreenWrapper>
            <ThemedView alignItems='center' justifyContent='center' flex={1} bg='bg-surface-primary'>
                <LottieView
                    source={require('../../../assets/lottie/sand_timer.json')}
                    style={{
                        width: 100,
                        height: 100,
                    }}
                    autoPlay={true}
                    loop={true}
                />
                <ThemedText mb='2xl' variant='b3b' color='text-primary'>Waiting for AutoPay completion</ThemedText>
                <ThemedView>
                    {LIST_ITEMS.map((item, index) => (
                        <ThemedView mb='lg' key={index} flexDirection='row' alignItems='center'>
                            <ThemedView bg='bg-surface-secondary' borderRadius='full' height={24} width={24} justifyContent='center' alignItems='center' mr='md'>
                                <ThemedText variant='b4r' color='text-primary'>
                                    {index + 1}
                                </ThemedText>
                            </ThemedView>
                            <ThemedText variant='b4r' color='text-primary' textAlign='left'>{item.title}</ThemedText>
                        </ThemedView>
                    ))}
                </ThemedView>
            </ThemedView>
        </ScreenWrapper>
    )
}

export default TataEsignProgress